/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StudioListingMediaGroupMembershipMoveOperation = {
  membershipId: string;
  afterId?: string | null;
  beforeId?: string | null;
};
export type moveStudioListingMediaGroupMembershipMutationVariables = {
  listingMediaGroupId: string;
  operations: Array<StudioListingMediaGroupMembershipMoveOperation>;
};
export type moveStudioListingMediaGroupMembershipMutationResponse = {
  readonly studioMoveListingMediaGroupMembership: {
    readonly success: boolean;
  };
};
export type moveStudioListingMediaGroupMembershipMutation = {
  readonly response: moveStudioListingMediaGroupMembershipMutationResponse;
  readonly variables: moveStudioListingMediaGroupMembershipMutationVariables;
};

/*
mutation moveStudioListingMediaGroupMembershipMutation(
  $listingMediaGroupId: String!
  $operations: [StudioListingMediaGroupMembershipMoveOperation!]!
) {
  studioMoveListingMediaGroupMembership(listingMediaGroupId: $listingMediaGroupId, operations: $operations) {
    success
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'listingMediaGroupId',
      },
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'operations',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'listingMediaGroupId',
            variableName: 'listingMediaGroupId',
          },
          {
            kind: 'Variable',
            name: 'operations',
            variableName: 'operations',
          },
        ],
        concreteType: 'StudioMoveListingMediaGroupMembershipResponse',
        kind: 'LinkedField',
        name: 'studioMoveListingMediaGroupMembership',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'success',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'moveStudioListingMediaGroupMembershipMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'moveStudioListingMediaGroupMembershipMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: 'c286e588826a2164e9aa6217d2e2f708',
      id: null,
      metadata: {},
      name: 'moveStudioListingMediaGroupMembershipMutation',
      operationKind: 'mutation',
      text: 'mutation moveStudioListingMediaGroupMembershipMutation(\n  $listingMediaGroupId: String!\n  $operations: [StudioListingMediaGroupMembershipMoveOperation!]!\n) {\n  studioMoveListingMediaGroupMembership(listingMediaGroupId: $listingMediaGroupId, operations: $operations) {\n    success\n  }\n}\n',
    },
  };
})();
(node as any).hash = 'aa051a1920ac8a7db5da3507600302a9';
export default node;
